<label class="custom-label" [formGroup]="parentForm" [for]="inputId">
  <span class="label-text">{{labelText}}</span>
  <input class="custom-input" [id]="inputId" [type]="inputType" [formControlName]="controlName">
</label>
